(function () {
    function changeRedeemHeading() {
        const heading = document.querySelector("#redeem .bon-item-title h1");

        if (heading) {
            const newHeading = document.createElement("h2");

            newHeading.className = heading.className;
            newHeading.innerHTML = heading.innerHTML;

            heading.replaceWith(newHeading);
            return true;
        }

        return false;
    }

    // Try immediately
    if (changeRedeemHeading()) return;

    // Watch for app content loaded later
    const observer = new MutationObserver(function () {
        if (changeRedeemHeading()) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();

(function () {
    function changeCookieHeading() {
        const heading = document.querySelector(".cookie-banner h2");

        if (!heading) return false;

        const newElement = document.createElement("p");
        newElement.className = heading.className;
        newElement.id = heading.id;
        newElement.innerHTML = heading.innerHTML;

        heading.replaceWith(newElement);
        return true;
    }

    if (changeCookieHeading()) return;

    const observer = new MutationObserver(function () {
        if (changeCookieHeading()) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();